import React, { useState } from "react";
import { Row, Col, Table, Button, Container, Spinner  } from "react-bootstrap";
import { endpoint } from "../../utils/api";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faEdit, faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFileImport, faEdit)


const SectionsTable = ({ sections, departmentPermission, setSectionID, setOpenNewModal, chosenDepartment}) => {
  const [chosenView, setChosenView] = useState("insert")
  const [IDLoading, setIDLoading] = useState("");

  const click = async (id) => {

    return Word.run(async (context) => {
      let url = endpoint + "/sections/section/import/" + id;
      fetch(url, 
        {
          headers: {
             Authorization: 'Bearer '+ localStorage.token,
             DepartmentName: chosenDepartment
         }
        }).then(function async(response) {
        response.json().then(function (data) {
          let text = Buffer.from(data.file, "hex").toString("utf8");
          context.document.getSelection().insertOoxml(text, "End");      
          context.sync();
          setIDLoading("");
        });
      });
    });
  };
  
  const handleInsertChange = () => {
    chosenView === "insert" ? setChosenView("edit") : setChosenView("insert")
  }
  return (
    <Table striped bordered hover>
   
      <thead>
        <tr>
          <th className="table-header" style={{width: "70px"}} >

            {departmentPermission ? 
            <Container fluid className="insert-edit-container" >
              <Row onClick={() => handleInsertChange()}>
                {chosenView === "edit" &&
                  <Button variant="light" className="insert-edit-toggle-buttons" >
                    <FontAwesomeIcon icon={faAngleLeft}  size='1x' className='all-font-icons' style={{fontSize: "16px"}} />
                  </Button>
                }
                {chosenView === "insert" ? "Insert" : "Edit"}

                {chosenView === "insert" &&
                  <Button variant="light" className="insert-edit-toggle-buttons" >
                    <FontAwesomeIcon icon={faAngleRight}  size='1x' className='all-font-icons' style={{fontSize: "16px"}} />
                  </Button>
                }
              </Row>
            </Container>
            :
            <Container fluid >
              Insert
            </Container>
            }

          </th>
          <th className="table-header align-middle">Name</th>
          <th className="table-header align-middle">Description</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(sections).map((section) => {
          return (
            <tr>
              <td className="align-top">
              
                <Container fluid className="table-buttons-container">
                {chosenView === "insert" ?
                <Button className="primary-button border-button insert-button" onClick={() => {click(sections[section]._id); setIDLoading(sections[section]._id)}} disabled={sections[section]._id === IDLoading}>

                  {sections[section]._id !== IDLoading ? 
                  <FontAwesomeIcon icon={faFileImport}  size='1x' className='all-font-icons' style={{marginBottom: "2px"}} />
                  :
                  <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      variant="light"
                  />
                  }
                </Button>
                :
                <Button 
                  variant="light" 
                  onClick={() => {setOpenNewModal(true); setSectionID(sections[section]._id)}}
                  className="insert-button"
                  >
                  <FontAwesomeIcon 
                      icon={faEdit}  
                      size='1x' 
                      className='all-font-icons' 
                    />
                </Button> 
                }
              </Container>
              
              </td>
              <td>{sections[section].name}</td>
              <td>{sections[section].description}</td>
              {/* <td>
                {sections[section].tags.map((tag) => {
                  return (
                    <>
                      <Badge bg="secondary">{tag}</Badge>{" "}
                    </>
                  );
                })}
              </td> */}

              
            </tr>
          );
        })}
      </tbody>
    </Table>
    
  );
};

export default SectionsTable;
